import React, { useState } from "react";
import ProductMenuItem from "./ProductsMenuItem";
import { ProductItem } from "./types";
import { Box } from "../Box";
import { Backdrop, styled, useTheme } from "@mui/material";
import LighthouseLogo from "../assets/lighthouse.svg";
import WorkspaceLogo from "../assets/workspaces.svg";
import AuraLogo from "../assets/aura.svg";
import ReefLogo from "../assets/reef.svg";
import AppsMenuIcon from "../assets/appsMenuIcon.svg";

import { Theme } from "../Theme";

const getDeafultProductsConfig = (theme: Theme): ProductItem[] => [
  {
    label: "Workspaces",
    link: "https://workspace-app-demo.shapedigital.com/",
    icon: <img src={WorkspaceLogo} alt="Workspaces" />,
  },
  {
    label: "Lighthouse",
    link: "https://demo-lh.shapedigital.com",
    icon: <img src={LighthouseLogo} alt="Lighthouse" />,
  },
  {
    label: "Aura",
    link: "https://aura-app-demo.shapedigital.com/",
    icon: <img src={AuraLogo} alt="Aura" />,
  },
  {
    label: "Reef",
    link: "https://bms-demo-app.azurewebsites.net/",
    icon: <img src={ReefLogo} alt="Reef" />,
  },
];

const ProductsMenu: React.FC<{
  overrideItems?: ProductItem[];
  productsMenuActiveItem?: string;
}> = ({ overrideItems, productsMenuActiveItem }) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme<Theme>();
  const menuItems = overrideItems || getDeafultProductsConfig(theme);

  return (
    <ProductsMenuContainer>
      <img
        src={AppsMenuIcon}
        alt="Apps Menu"
        style={{ width: "20px", height: "20px" }}
        onClick={() => setIsOpen(!isOpen)}
      />

      <Backdrop
        sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1 })}
        open={isOpen}
        onClick={() => setIsOpen(false)}
      >
        <StyledWrapper>
          {menuItems.map((item) => (
            <ProductMenuItem
              {...item}
              isActive={productsMenuActiveItem === item.label}
              key={item.label}
            />
          ))}
        </StyledWrapper>
      </Backdrop>
    </ProductsMenuContainer>
  );
};

export default ProductsMenu;
const StyledWrapper = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  width: "11rem",
  boxSizing: "border-box",
  alignItems: "center",
  padding: 0,
  position: "fixed",
  right: "1rem",
  top: "4rem",
  border: `1px solid ${theme.tokens.colors.gray[3]}`,
  gap: "1px",
  backgroundColor: theme.tokens.colors.gray[3],
  zIndex: 9,
  boxShadow: "0px 6px 30px 5px #0000001F",
}));
const ProductsMenuContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "20px",
  padding: 0,
  svg: {
    color: theme.tokens.colors.gray[6],
  },
  display: "flex",
  alignItems: "center",
  img: {
    cursor: "pointer",
  },
}));
